import { TreeItem } from './getTreeData';

type MainProps = [string[], TreeItem[], string];

const getAllChildrenIds = (children: TreeItem[]) => {
  const selected = children.map(({ id }) => id);

  children.forEach(({ children }) => {
    selected.push(...getAllChildrenIds(children));
  });

  return selected;
};

const getAllChildrenChecked = (treeData: TreeItem[], clickedItem: string) => {
  const item = treeData.find(({ id }) => id === clickedItem);
  if (item) {
    return [clickedItem, ...getAllChildrenIds(item.children)];
  }

  const checkedIds = [] as string[];

  treeData.forEach((child) => {
    checkedIds.push(...getAllChildrenChecked(child.children, clickedItem));
  });

  return checkedIds;
};

const getAllParents = (treeData: TreeItem[], clickedItem: string, id?: string) => {
  const parentIds = [] as string[];

  const item = treeData.find(({ id }) => id === clickedItem);

  if (id && item) return [id];

  treeData.forEach((child) => {
    const childIds = getAllParents(child.children, clickedItem, String(child.id));

    if (!childIds.length) return;

    parentIds.push(...childIds);

    if (!id) return;

    parentIds.push(id);
  });

  return parentIds;
};

const itemWasSelected = (...props: MainProps) => {
  const [checkedIds, treeData, clickedItem] = props;
  const checked = [...checkedIds] as string[];

  checked.push(...getAllChildrenChecked(treeData, clickedItem));

  return [...new Set(checked)];
};

const itemWasCanceled = (...props: MainProps) => {
  const [checkedIds, treeData, clickedItem] = props;

  const checked = checkedIds
    .filter((id) => !getAllChildrenChecked(treeData, clickedItem).includes(id))
    .filter((id) => !getAllParents(treeData, clickedItem).includes(id));

  return [...new Set(checked)];
};

export const checkIdsWithChildren = (...props: MainProps) => {
  const [checkedIds, _treeData, clickedItem] = props;
  const isClickedItemSelected = clickedItem ? checkedIds.includes(clickedItem) : false;

  if (isClickedItemSelected) return itemWasSelected(...props);

  return itemWasCanceled(...props);
};
